import { useMediaQuery } from "@mantine/hooks";

import { QuoteRequestsTableData } from "#app/routes/pages/quote-requests/QuoteRequestsV2.page";
import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";
import { Text } from "#components/atoms/Typographies/Text";
import { Center } from "#shared/view/components/Center";
import { Flex } from "#shared/view/components/Flex";
import { Paper } from "#shared/view/components/Paper";
import { ThumbnailOverlay } from "#shared/view/components/Thumbnails/ThumbnailOverlay";

const THUMBNAIL_SIZE = { width: 48, height: 48 };

const getMaxPartsToDisplay = (isMd: boolean, isLg: boolean) => {
  if (isLg) {
    return 12;
  }
  if (isMd) {
    return 8;
  }
  return 6;
};

type Props = {
  quoteRequest: QuoteRequestsTableData;
};

export const QuoteRequestPartsCell = ({ quoteRequest }: Props) => {
  const isMd = useMediaQuery("(min-width: 1440px)");
  const isLg = useMediaQuery("(min-width: 1920px)");
  const maxParts = getMaxPartsToDisplay(isMd, isLg);

  const moreParts = `+${quoteRequest.uniqueLines.length - maxParts}`;

  return (
    <Flex gap={spacing[2]} style={{ overflowInline: "clip", overflowBlock: "visible" }}>
      {quoteRequest.uniqueLines.slice(0, maxParts).map((line) => (
        <ThumbnailOverlay key={line.id} part={line.part} size={THUMBNAIL_SIZE} />
      ))}
      {quoteRequest.uniqueLines.length > maxParts && (
        <Paper
          h={THUMBNAIL_SIZE.height}
          w={THUMBNAIL_SIZE.width}
          radius="sm"
          withBorder
          bg={colors.bg.elevation.quaternary}
        >
          <Center h="100%" w="100%">
            <Text size="small" type="medium">
              {moreParts}
            </Text>
          </Center>
        </Paper>
      )}
    </Flex>
  );
};
